import React from "react";
import PropTypes from "prop-types";
import { Segment } from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";

const ItemsList = ({
  itemData,
  href,
  prevagent,
  activeagent,
  header,
  getData,
  customclass,
  ...props
}) => {
  let data = itemData.length;
  let page_size = 3;
  let indexdata = (activeagent - 1) * page_size;

  return (
    <Segment basic style={{ padding: 0 }}>
      {itemData
        .slice(indexdata)
        .slice(0, page_size)
        .map((item, index) => (
          <ItemData
            id={item.id}
            key={index}
            href={href + "?id=" + item.id}
            size={item.size}
            source={item.image}
            head={item.head}
            subhead={item.subhead}
            desc={item.desc ? item.desc : null}
            extra={item.extra ? item.extra : null}
            header={header}
            customclass={customclass}
            license={item.license ? item.license : null}
            onClick={(e) =>
              getData ? getData(e, item.head) : e.preventDefault
            }
          />
        ))}
      {itemData.length > 3 && (
        <Paginate
          length={data}
          prev={prevagent}
          active={activeagent}
          {...props}
        />
      )}
    </Segment>
  );
};

ItemsList.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default ItemsList;
